'use client';

import { OperationsIcon } from '@/components/icons';
import { useHasRole } from '@/hooks/useCurrentUserRoles';
import NavIconLink from './NavIconLink';

export default function OperationsDropdown() {
  const { hasRole: isSaxUser, isLoading } = useHasRole('Sax');

  if (isLoading || !isSaxUser) {
    return null;
  }

  return (
    <NavIconLink href="/operations" label="Operations">
      <OperationsIcon className="h-6 w-6" />
    </NavIconLink>
  );
}
